import ERROR_MESSAGES from "@/utils/errors/errorMessages";
import { config } from "@/config";
import axios from "axios";
import Cookies from "js-cookie";
import { AppError } from "@utils/errors/appError";

const getAuthToken = () => {
  return Cookies.get("x_access_token");
};

export const apiClient = axios.create({
  baseURL: config.site.apiUrl,
});

apiClient.interceptors.request.use(
  (axiosConfig) => {
    const authToken = getAuthToken();
    if (authToken) {
      axiosConfig.headers.Authorization = `Bearer ${authToken}`;
    }
    return axiosConfig;
  },
  (error: Error) => {
    return Promise.reject(error);
  },
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      Cookies.remove("x_access_token");
      localStorage.removeItem("user");
      return Promise.reject(
        new AppError("Sessão expirada. Por favor, faça login novamente."),
      );
    }

    if (error.response?.data?.message) {
      const errorMessage = error.response.data.message;
      const translatedMessage =
        ERROR_MESSAGES[errorMessage] ||
        "Erro desconhecido. Tente novamente mais tarde.";
      return Promise.reject(new AppError(translatedMessage));
    }

    return Promise.reject(
      new AppError("Erro no servidor. Tente novamente mais tarde!"),
    );
  },
);
